import Big from "big.js";
import store from "../store";
import { labelForCode, codeFromHasTax } from "./taxCatalog";

const PurchaseItem = class {
    constructor(object) {
        if (object === undefined) {
            this.id = null
            this.code = null
            this.productId = null
            this.product = null;
            this.hasTax = false;
            this.ivaCode = '0';
            this.iceCode = null;
            this.iceValue = new Big('0.0');
            this.irbpnrValue = new Big('0.0');
            this.amount = new Big('0.0');
            this.discount = new Big('0.0');
            this.readableDiscount = new Big('0.0');
            this.unitPrice = new Big('0.0');
            this.receiptLine = null;
            this.lineSubtotal = null;
            this.needsReview = false;
        } else {
            this.id = object.id || null;
            this.code = object.code || null;
            this.productId = object.productId;
            this.product = object.product;
            this.hasTax = object.hasTax;
            this.ivaCode = object.ivaCode || codeFromHasTax(object.hasTax, store.getters.business.taxPercentage);
            // ICE congelado del item (lo calcula el backend desde el producto, o lo trae
            // la línea del comprobante si el ítem está enlazado).
            this.iceCode = object.iceCode || null;
            this.iceValue = (object.iceValue !== undefined && object.iceValue !== null) ? new Big(object.iceValue) : new Big('0.0');
            this.irbpnrValue = (object.irbpnrValue !== undefined && object.irbpnrValue !== null) ? new Big(object.irbpnrValue) : new Big('0.0');
            this.amount = (object.amount !== undefined) ? new Big(object.amount) : new Big('1.0');
            this.discount = (object.discount !== undefined) ? new Big(object.discount) : new Big('0.0');
            this.readableDiscount = this.discount.times(100).round(2);
            this.unitPrice = (object.unitPrice !== undefined) ? new Big(object.unitPrice) : new Big('0.0');
            // Enlazado a una línea del comprobante (ver models/receiptXML.js): su total es
            // el subtotal de la línea, así que el precio unitario sale de la cantidad.
            this.receiptLine = (object.receiptLine !== undefined && object.receiptLine !== null) ? object.receiptLine : null;
            this.lineSubtotal = (object.lineSubtotal !== undefined && object.lineSubtotal !== null) ? new Big(object.lineSubtotal) : null;
            // La cantidad salió de un cambio de unidad del proveedor: hay que confirmarla.
            this.needsReview = object.needsReview === true;
            if (this.lineSubtotal !== null) {
                this.discount = new Big('0.0');
                this.readableDiscount = new Big('0.0');
                this.unitPrice = this.amount.gt(0) ? this.lineSubtotal.div(this.amount) : new Big('0.0');
            }
        }
        this.readableTax = labelForCode(this.ivaCode);
    }

    get totalPrice() {
        return this.unitPrice.times(this.amount).times(this.discount.times(-1).plus(1)).round(2);
    }

    // Costo del lote: el precio más el ICE y el IRBPNR que el comprador asume. Espeja
    // PurchaseItem.costTotal del backend.
    get costTotal() {
        return this.totalPrice.plus(this.iceValue).plus(this.irbpnrValue).round(2);
    }

    get isLinked() {
        return this.receiptLine !== null;
    }
}

export default PurchaseItem
